<template>
  <list-item
    :booking="booking"
    :link="{ name: 'bookings.show', params: { id: booking.id } }"
  >
    <template v-slot:title>{{ booking.name }}</template>

    <template v-slot:meta>
      <meta-item :is-name="true" icon="user">
        {{ bookingAttendingTalentNames }}
      </meta-item>
    </template>

    <template v-slot:hero>View</template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'
import MetaItem from '../list/meta/MetaItem'
import { map } from 'lodash'

export default {
  mixins: [helpers],
  components: {
    ListItem,
    MetaItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    bookingAttendingTalentNames () {
      let talent = map(this.bookingAttendingTalent, 'name')

      if (talent.length > 1) {
        return `${talent.slice(0, -1).join(', ')} and ${talent.slice(-1)}`
      } else {
        return talent.join(', ')
      }
    }
  }
}
</script>
